import { render, staticRenderFns } from "./FormaPgto.vue?vue&type=template&id=7c2e1e3b"
import script from "./FormaPgto.vue?vue&type=script&lang=js"
export * from "./FormaPgto.vue?vue&type=script&lang=js"
import style0 from "./FormaPgto.vue?vue&type=style&index=0&id=7c2e1e3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports